@if (isSuccessState()) {
  <div class="form">
    <div class="text-b3-l-700 text-md-h4-s">Завка отправлена</div>

    <div class="text-b4-m-300 text-md-b2-s-300">
      Спасибо за вашу заявку.
      <br />
      <br />
      <div>Как только менеджер соберёт всю необходимую информацию, мы свяжемся с вами для оформления заказа</div>
    </div>

    <button sdButton fullWidth="true" (click)="closeModal()">понятно</button>
  </div>
} @else {
  <form [formGroup]="form" class="form" action="submit" [class.sd-app]="isSdvorApp()">
    <div class="text-b3-l-700 text-md-h4-s" data-analytics="send_request_form">Оставить заявку</div>
    <div class="text-b4-m-300 text-md-b1-m-300">мы свяжемся с вами в ближайшее время</div>

    <sd-input
      class="form-input-phone"
      label="номер телефона"
      error="{{
        form.controls.phone.errors?.invalidPhone && form.controls.phone.touched
          ? 'номер телефона введён некорректно'
          : ''
      }}"
    >
      <input
        #phoneInput
        class="input-phone"
        type="tel"
        autocomplete="tel"
        inputmode="numeric"
        autofocus
        sdPhoneMask
        sdPhoneAuthorizedUser
        [formControl]="form.controls.phone"
        (focus)="onPhoneFocus()"
        (blur)="onPhoneBlur()"
      />
    </sd-input>

    @if (productTransitPrice()?.multiplicity && productTransitPrice()?.multiplicity > 1) {
      <div class="text-b4-m-300 text-md-b1-m-300">
        количество товара в заявке должно быть кратно {{ productTransitPrice()?.multiplicity }}
        {{ productTransitPrice()?.unit.name }}
      </div>
    }
    <div class="counter">
      <sd-product-item-counter
        formControlName="quantity"
        [selectedPrice]="productTransitPrice()"
        [showSaleUnit]="true"
        [isStepCount]="true"
      ></sd-product-item-counter>
    </div>

    @if (product().units?.length) {
      <div class="units">
        @for (unit of product().units; track unit.baseUnit.code) {
          <button
            class="unit"
            [class.unit__selected]="unit.baseUnit.code === selectedUnitCode()"
            (click)="selectUnitCode(unit.baseUnit.code)"
          >
            {{ unit.baseUnit.name }}
          </button>
        }
      </div>
    }

    <div class="total-price">
      <div>
        <span class="text-b4-m-300 text-md-b1-m-300">итого</span>
        <span class="text-b4-l-700 text-md-b1-l-700">{{ totalPrice() }} ₽</span>
      </div>
      <div class="text-c2-l-300 text-md-c1-l-300">цена указана без стоимости доставки</div>
    </div>

    <div class="submit">
      <button
        sdButton
        fullWidth="true"
        [disabled]="form.controls.phone.errors?.invalidPhone || !form.controls.phone.value"
        (click)="onSubmit()"
      >
        отправить заявку
      </button>
      <sd-personal-data-agree-text-callback></sd-personal-data-agree-text-callback>
    </div>
  </form>
}
